// extracted by mini-css-extract-plugin
export var container = "_4k-0";
export var disabled = "_4k-4";
export var fullWidth = "_4k-3";
export var lined = "_4k-1";
export var selected = "_4k-5";
export var tab = "_4k-2";